module.exports = {
  localeName: 'pl-PL',
  momentFormat: 'DD-MM-YYYY',
};
